export { default } from '@esentai/core/features/efsVisitRecords/api';
